import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  // List,
  ListItem,
  withStyles,
  Hidden,
  Grid,
  ListItemSecondaryAction,
} from '@material-ui/core'
import {
  oldestFirstSelector,
  newestFirstSelector,
  scheduledLatestSelector,
  scheduledOldestSelector,
  mostOpensSelector,
  mostSendsSelector,
  mostClicksSelector,
} from 'selectors/tasks'
import Scheduler from '../Scheduler'
import Menu from './Menu'
import types from './types'
import Stats from './Stats'
import Sort from './Sort'
import classNames from 'classnames'
import language from 'utils/vast-languagepack'
import Icon from '@mdi/react'
import { mdiPlus } from '@mdi/js'
import { toggleView } from 'actions/tasks'
import { toggleTaskModal } from 'actions/campaign/addOrEdit'
import {
  List as VirtualizedList,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized'
// import { DropTarget } from 'react-dnd'
import './tasks.css'
import { DropTarget } from 'react-dnd'

const List = DropTarget(
  ['taskType'],
  {
    drop(props, monitor) {
      console.log('drop')
      if (monitor.getItemType() === 'taskType') {
        props.onDrop(monitor.getItem())
      }
    },
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    didDrop: monitor.didDrop(),
  }),
)(
  class ListComponent extends Component {
    componentDidUpdate(prevProps) {
      if (
        this.props.sort !== prevProps.sort ||
        this.props.tasksLength !== prevProps.tasksLength
      ) {
        this.props.cache.clearAll()
        this.props.largeCache.clearAll()
        if (this?.smallList && this.smallList?.forceUpdateGrid) {
					this.smallList.forceUpdateGrid()
				}
        if (this?.largeList && this.largeList?.forceUpdateGrid) {
					this.largeList.forceUpdateGrid()
				}
      }
    }

    bindSmallListRef = (ref) => {
      this.smallList = ref
    }

    bindLargeListRef = (ref) => {
      this.largeList = ref
    }

    render() {
      const {
        classes,
        list,
        cache,
        largeCache,
        renderSmallRow,
        renderLargeRow,
        connectDropTarget,
      } = this.props

      return connectDropTarget(
        <div className={classes.window}>
          <Hidden mdUp>
            <AutoSizer>
              {({ width, height }) => (
                <VirtualizedList
                  ref={this.bindSmallListRef}
                  width={width}
                  height={height}
                  deferredMeasurementCache={cache}
                  rowHeight={cache.rowHeight}
                  rowRenderer={renderSmallRow}
                  rowCount={list.length}
                  overscanRowCount={3}
                />
              )}
            </AutoSizer>
          </Hidden>
          <Hidden smDown>
            <AutoSizer>
              {({ width, height }) => (
                <VirtualizedList
                  ref={this.bindLargeListRef}
                  width={width}
                  height={height}
                  deferredMeasurementCache={largeCache}
                  rowHeight={largeCache.rowHeight}
                  rowRenderer={renderLargeRow}
                  rowCount={list.length}
                  overscanRowCount={10}
                />
              )}
            </AutoSizer>
          </Hidden>
        </div>
      )
    }
  },
)

export default connect(
  (state) => ({
    viewSelected: state.tasks.viewSelected,
    oldestFirst: oldestFirstSelector(state),
    newestFirst: newestFirstSelector(state),
    scheduledLatest: scheduledLatestSelector(state),
    scheduledOldest: scheduledOldestSelector(state),
    mostOpens: mostOpensSelector(state),
    mostSends: mostSendsSelector(state),
    mostClicks: mostClicksSelector(state),
    sort: state.tasks.sort,
    viewManuallySelected: state.tasks.viewManuallySelected,
    // tasksLength: Object.keys(state.tasks.tasksByID).length,
  }),
  (dispatch) => bindActionCreators({ toggleView, toggleTaskModal }, dispatch),
)(
  withStyles((theme) => ({
    listContainer: {},
    list: {
      padding: 0,
    },
    expandPanelIcon: {
      color: theme.palette.secondary.main,
      textAlign: 'center',
      position: 'absolute',
      left: 43,
      top: '50%',
      [theme.breakpoints.down('sm')]: {
        // top: 65,
        left: 40,
      },
    },
    expandPanelIconStats: {
      top: 34,
    },
    expandPanelIconTypography: {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
      fontSize: '9px',
      width: 73,
      lineHeight: 1.3,
      marginTop: '-4px',
    },
    expandPanelIconInner: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'bold',
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      marginBottom: 5,
    },
    description: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(15),
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      marginBottom: 5,
    },
    createdHeading: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'bold',
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(11),
      },
    },
    text: {
      display: 'table-cell',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    createdDate: {
      color: theme.palette.secondary.main,
      display: 'inline-block',
    },
    secondaryAction: {
      [theme.breakpoints.up('xs')]: {
        paddingRight: 33,
      },
      [theme.breakpoints.up('md')]: {
        paddingRight: 60,
      },
    },
    container: {
      borderStyle: 'solid',
      backgroundColor: '#fff',
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: '#adadad',
      borderRadius: 35,
      listStyle: 'none',
      marginRight: 5,
    },
    even: {
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: '#C0DEFB',
      },
    },
    odd: {
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: '#C0DEFB',
      },
    },
    secondaryActionRoot: {
      [theme.breakpoints.up('xs')]: {
        top: 'calc(50% - 16px)',
      },
      [theme.breakpoints.up('md')]: {
        top: 'calc(50% - 24px)',
      },
    },
    secondaryActionRootStats: {
      [theme.breakpoints.up('xs')]: {
        top: 'calc(50% - 16px)',
      },
      [theme.breakpoints.up('md')]: {
        top: 'calc(50% - 24px)',
      },
    },
    info: {
      display: 'inline-block',
      marginLeft: 75,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 68,
      },
    },
    window: {
      height: 'calc(100vh - 385px)',
      [theme.breakpoints.down('sm')]: {
        height: 'calc(100vh - 316px)',
      },
      [theme.breakpoints.down('xs')]: {
        height: 'calc(100vh - 237px)',
      },
    },
  }))(
    class Tasks extends Component {
      constructor() {
        super()
        this.cache = new CellMeasurerCache({
          fixedWidth: true,
          defaultHeight: 110,
        })
        this.largeCache = new CellMeasurerCache({
          fixedWidth: true,
          defaultHeight: 110,
        })
      }

      componentDidMount() {
        if (
          this.props.viewManuallySelected === 'calendar' ||
          this.props.ownedBy
        ) {
          this.props.toggleView('calendar')
        }
      }

      componentDidUpdate(prevProps) {
        if (
          this.props.sort !== prevProps.sort ||
          this.props.tasksLength !== prevProps.tasksLength
        ) {
          this.cache.clearAll()
          this.largeCache.clearAll()
          if (this.smallList) {
            this.smallList.forceUpdateGrid()
          }
          if (this.largeList) {
            this.largeList.forceUpdateGrid()
          }
        }
        // if (this.props.tasksLength !== prevProps.tasksLength) {
        //   console.log('if (this.props.tasksLength !== prevProps.tasksLength) {')
        //   this.forceUpdate()
        // }
      }

      componentWillUnmount() {
        this.props.toggleView('list')
      }

      list = () => {
        const { ownedBy, sort } = this.props

        return ownedBy
          ? this.props[sort].filter((task) => {
              if (
                task.owned_by &&
                task.owned_by.id === ownedBy.id &&
                task.owned_by.type === ownedBy.type
              ) {
                return true
              }
              return false
            })
          : this.props[sort]
      }

      listItem = (size, index) => {
        const { classes, history } = this.props
        const task = this.list()[index]
        const date = new Date(task.when_created)
        const stats = task.email_stats || task.sms_stats

        return (
          <ListItem
            // onClick={() => history.push(`tasks/${task.id}`)}
            onClick={() => this.props.toggleTaskModal(task)}
            key={`tasksPageListItem${task.id}`}
            button
            classes={{
              container: classes.container,
              secondaryAction: classes.secondaryAction,
            }}
          >
            <div className={classNames(classes.expandPanelIcon)}>
              {types(task, classes).icon}
            </div>
            <Grid container className={classes.info}>
              <Grid item md={12} lg={6}>
                <div className={classes.heading}>
                  <span className={classes.text}>{task.name}</span>
                </div>
              </Grid>
              <Grid item md={12} lg={6}>
                <div className={classes.description}>
                  <span className={classes.text}>{task.description}</span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.createdHeading}>
                  <span className={classes.text}>
                    <em>
                      <span>
                        <span>{language.task.menuSort.created}</span>
                        <span className={classes.createdDate}>
                          {`${date.toLocaleDateString()}`}
                        </span>
                      </span>
                      {types(task, classes).scheduled}
                    </em>
                  </span>
                </div>
              </Grid>
              {size === 'small' ? (
                <Grid item xs={12}>
                  <div>
                    <Stats task={task} />
                  </div>
                </Grid>
              ) : null}
            </Grid>
            {size === 'large' ? <Stats task={task} /> : null}
            <ListItemSecondaryAction
              classes={{
                root: stats
                  ? classes.secondaryActionRootStats
                  : classes.secondaryActionRoot,
              }}
            >
              <Menu
                vert
                task={task}
                // taskName={task.name}
                // taskID={task.id}
                history={history}
              />
            </ListItemSecondaryAction>
          </ListItem>
        )
      }

      renderSmallRow = ({ index, key, style, parent }) => {
        const list = this.list()

        return (
          <CellMeasurer
            key={key}
            cache={this.cache}
            parent={parent}
            columnIndex={0}
            rowIndex={index}
          >
            <div
              style={{
                ...style,
                paddingBottom: index !== list.length - 1 ? 10 : 0,
              }}
            >
              {this.listItem('small', index)}
            </div>
          </CellMeasurer>
        )
      }

      renderLargeRow = ({ index, key, style, parent }) => {
        const list = this.list()

        return (
          <CellMeasurer
            key={key}
            cache={this.largeCache}
            parent={parent}
            columnIndex={0}
            rowIndex={index}
          >
            <div
              style={{
                ...style,
                paddingBottom: index !== list.length - 1 ? 10 : 0,
              }}
            >
              {this.listItem('large', index)}
            </div>
          </CellMeasurer>
        )
      }

      bindSmallListRef = (ref) => {
        this.smallList = ref
      }

      bindLargeListRef = (ref) => {
        this.largeList = ref
      }

      render() {
        const {
          classes,
          viewSelected,
          history,
          ownedBy,
          campaignPage,
        } = this.props

        const list = this.list()

        const calendarComponentRef = createRef()

        const noTasks = (
          <div
            style={{
              textAlign: 'center',
              padding: '13px',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              border: 'solid 1px #adadad',
              borderRadius: '35px',
            }}
          >
            <div style={{ marginTop: '40px' }}>
              {language.task.menuSort.noDisplay}
            </div>
            <div
              style={{
                backgroundColor: '#014c94',
                color: '#ffffff',
                padding: '1%',
                maxWidth: '300px',
                borderRadius: '20px',
                margin: '40px auto 40px auto',
                border: '1px solid black',
                cursor: 'pointer',
                boxShadow:
                  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
              }}
              onClick={() => this.props.toggleTaskModal(true)}
            >
              <Icon path={mdiPlus} size={4} color="white" />
              <br />
              {language.task.add.labels.createTask}
            </div>
          </div>
        )

        return (
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <Sort ref={calendarComponentRef} campaignPage={campaignPage} />
            </Grid>
            <Grid item xs={12}>
              {viewSelected === 'list' ? (
                list.length ? (
                  <List
                    onDrop={(item) => console.log(item)}
                    classes={classes}
                    list={list}
                    cache={this.cache}
                    largeCache={this.largeCache}
                    renderSmallRow={this.renderSmallRow}
                    renderLargeRow={this.renderLargeRow}
                  />
                ) : (
                  noTasks
                )
              ) : (
                <Scheduler
                  ref={calendarComponentRef}
                  ownedBy={ownedBy}
                  history={history}
                />
              )}
            </Grid>
          </Grid>
        )
      }
    },
  ),
)
